export default __webpack_public_path__ + "static/media/icon-start-making-money-blue.f9886e57.svg";